import { IdLabelDictionary } from "../../../models/staticData";
import { Header } from "./shared/data-table/table-header"; 

export const slaStatusOptions: IdLabelDictionary = {
  0: "Green",
  1: "Amber",
  2: "Red", 
}

export const statusOptions: IdLabelDictionary = {
  0: "Claimed",
  1: "Closed",
  2: "AwaitingCustomer",
  3: "Unclaimed",
  4: "Successful",
  5: "Unsuccessful",
};

export const tableHeaders: Header[] = [
  { label: "Case#", width: "172px" },
  { label: "Client#" },
  { label: "Group" },
  { label: "Account#" },
  { label: "Time Remaining", width: "172px", sortKey: "slatime" },
  { label: "Email" },
  { label: "Subject", width: "300px" },
  { label: "Description", width: "300px" },
  { label: "Classification" },
  { label: "Team" },
  { label: "Status" },
  { label: "Owner" },
  { label: "Confidence" },
  { label: "Create Date", width: "139px", sortKey: "createddate" },
];